import { render, staticRenderFns } from "./yichang.vue?vue&type=template&id=bdb8e0c8&scoped=true&"
import script from "./yichang.vue?vue&type=script&lang=ts&"
export * from "./yichang.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb8e0c8",
  null
  
)

export default component.exports